const t="/advert/detail/init",e="/advert/detail/load-reviews",a="apiAdvertDetail";export{t as INIT_URL,e as LOAD_REVIEWS_URL,a as API_ADVERT_DETAIL_NAME};
